<template>
    <div
        class="p-6 pt-15 text-blue-500 bg-white rounded shadow-md overflow-scroll absolute w-full h-full"
    >
        <!-- prettier-ignore -->
        <svg
            class="icon--cross absolute top-0 right-0 mt-6 mr-6 w-5 cursor-pointer"
            role="img" focusable="false"
            viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"
            @click="$emit('close')"
        >
            <path fill="currentColor" d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z" />
        </svg>

        <p class="flex justify-between font-medium text-blue-500">
            {{ item.title }}

            <span class="flex flex-wrap justify-end flex-1 ml-4 align-start">
                <span
                    class="self-center inline-block px-1 mt-1 text-sm font-medium whitespace-no-wrap border rounded"
                >
                    {{ item['categories.lvl0'][0] }}
                </span>

                <span
                    v-for="service in item.services"
                    :key="service"
                    class="self-center inline-block px-1 mt-1 ml-1 text-sm font-medium whitespace-no-wrap border rounded"
                >
                    {{ service }}
                </span>
            </span>
        </p>

        <ul class="mt-6 mb-4 text-sm">
            <li class="flex mt-5">
                <svg
                    class="w-3 h-3 mt-1 mr-3"
                    viewBox="0 0 12 13"
                    role="img"
                    focusable="false"
                    aria-label="Address"
                    fill="none"
                >
                    <path
                        d="M6.008 11.558a16.667 16.667 0 01-1.985-2c-1.045-1.256-1.94-2.77-1.94-4.19C2.083 3.064 3.868 1.25 6 1.25c2.125 0 3.916 1.816 3.916 4.117 0 1.61-.908 3.135-1.938 4.33a13.57 13.57 0 01-1.97 1.861z"
                        class="stroke-current"
                        stroke-width="1.5"
                    />
                    <rect x="5" y="4.25" width="2" height="2" rx="1" class="fill-current" />
                </svg>

                <p class="text-grey-500">
                    {{ item.address }}<br />
                    <a
                        :href="
                            item.googleMapsShareLink ||
                            `https://www.google.com/maps/search/?api=1&query=${item.address}`
                        "
                        class="text-blue-500"
                        :aria-label="'Directions to ' + item.title"
                    >
                        Directions <sup aria-hidden="true">&nearr;</sup>
                    </a>
                </p>
            </li>

            <li class="flex mt-5">
                <svg
                    class="w-3 h-3 mt-1 mr-3 flex-shrink-0"
                    viewBox="0 0 12 13"
                    role="img"
                    focusable="false"
                    aria-label="Opening hours"
                    fill="none"
                >
                    <circle cx="6" cy="6.5" r="5.25" class="stroke-current" stroke-width="1.5" />
                    <path
                        d="M5.906 3.25v3.969M5.156 6.484h3.969"
                        class="stroke-current"
                        stroke-width="1.5"
                    />
                </svg>
                <div class="">
                    <p v-for="(group, i) in openingTimes" :key="i" class="text-grey-500">
                        {{ group }}
                    </p>

                    <p class="text-grey-500">(ACST/ACDT)</p>
                    <li v-if="item.openingHoursNote" class="flex my-4">
                        <div
                            v-if="item.openingHoursNote"
                            class="small wysiwyg wysiwyg--super-condensed text-grey-500"
                            v-html="item.openingHoursNote"
                        ></div>
                    </li>

                    <div
                        v-for="(exception, i) in visibleExceptions"
                        :key="i"
                        class="my-2 text-grey-500"
                    >
                        <p class="font-bold">{{ exception.note }}</p>
                        <p class="">{{ exception.readable }}</p>
                    </div>
                </div>
            </li>
            <li v-if="item.note">
                <div class="wysiwyg mt-3" v-html="item.note"></div>
            </li>
        </ul>

        <div class="flex mt-6 -mx-2">
            <a
                v-if="item.phone"
                class="w-1/2 mx-2 btn btn--no-min"
                :href="'tel:' + item.phone"
                target="_blank"
                >Call</a
            >
            <a
                v-if="item.website"
                class="w-1/2 mx-2 btn btn--no-min"
                :href="item.website"
                target="_blank"
                >Website</a
            >
        </div>
    </div>
</template>

<script>
import { formatOpeningTimes, visibleExceptions } from './util-opening-times';

export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        openingTimes() {
            return formatOpeningTimes(this.item.hours);
        },
        visibleExceptions() {
            return visibleExceptions(this.item.openingHoursExceptions);
        }
    }
};
</script>
